export default function loadHeroImage(images, cardType) {
  if (images.background_image_url_1x) {
    switch (cardType) {
      case "rectangular":
        return images.background_image_url_1x.replace("w=720&h=360", "w=900&h=450")
      case "square":
        return images.background_image_url_1x.replace("w=720&h=360", "w=336&h=200")
      default:
        if (window.innerWidth >= "1444px") {
          return images.background_image_url_3x
        } else {
          return images.background_image_url_2x
        }
    }
  } else {
    return null
  }
}
